import { useEffect, useRef } from "react";

interface EqualizerPlayingAnimationProps {
  height?: number;
  barWidth?: number;
  barCount?: number;
  barColor?: string;
  backgroundColor?: string;
  animated?: boolean;
  className?: string;
}

const EqualizerPlayingAnimation = ({
  height = 40,
  barWidth = 4,
  barCount = 5,
  barColor,
  backgroundColor = "transparent",
  animated = true,
  className = "",
}: EqualizerPlayingAnimationProps) => {
  const barsRef = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    if (!animated) return;

    const updateBars = () => {
      barsRef.current.forEach((bar) => {
        if (!bar) return;
        const targetHeight = Math.random() * height * 0.777 + height * 0.05;
        bar.style.height = `${targetHeight}px`;
      });
    };

    updateBars();
    const interval = setInterval(updateBars, 100);

    return () => clearInterval(interval);
  }, [animated, height]);

  return (
    <div className={`flex items-end gap-1 ${className}`} style={{ height, backgroundColor }}>
      {[...Array(barCount)].map((_, index) => (
        <div
          key={index}
          ref={(el) => el && (barsRef.current[index] = el)}
          style={{
            width: barWidth,
            height: height * 0.4,
            backgroundColor: barColor || "#FACC15",
            transition: "height .3s linear",
          }}
          className="rounded"
        />
      ))}
    </div>
  );
};

export default EqualizerPlayingAnimation;
